/**
 * Тема оформления (НФ-17): светлая, тёмная — для работы вечером и на площадке — или как в системе.
 * Выбор хранится в браузере человека; цвета обеих тем — из брендбука (packages/brand).
 */
export type ThemePref = 'light' | 'dark' | 'system';

export const THEME_TITLES: Record<ThemePref, string> = {
  light: 'Светлая',
  dark: 'Тёмная',
  system: 'Как в системе',
};

const KEY = 'epc:theme';
const EVENT = 'epc:theme';
const media = () => window.matchMedia?.('(prefers-color-scheme: dark)');

export function getThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : 'light';
  } catch {
    return 'light';
  }
}

function apply(pref: ThemePref) {
  const dark = pref === 'dark' || (pref === 'system' && Boolean(media()?.matches));
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
}

export function setThemePref(pref: ThemePref) {
  try {
    localStorage.setItem(KEY, pref);
  } catch {
    // хранилище браузера недоступно — тема действует до перезагрузки страницы
  }
  apply(pref);
  window.dispatchEvent(new Event(EVENT));
}

/** Применить тему до первой отрисовки и следить за сменой темы системы */
export function initTheme() {
  apply(getThemePref());
  media()?.addEventListener?.('change', () => {
    if (getThemePref() === 'system') apply('system');
  });
}

export function subscribeTheme(cb: () => void) {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
